import { useWebsite } from 'hooks/website/useWebsite';

import s from './OrganicPreviewImage.module.css';

export const OrganicPreviewImage = () => {
  const {
    home: {
      hero: { image: heroImageSrc },
    },
  } = useWebsite();

  return (
    <div
      role="img"
      title="Organic Image Preview"
      className={s.image}
      style={{
        backgroundImage: `url(${heroImageSrc})`,
      }}
    />
  );
};
